import React, { useRef, useState } from "react"
import { FiFile, FiCheckCircle, FiUploadCloud } from "react-icons/fi"
import useUploader from "../../hooks/useUploader"
import "./style.css"

const ACCEPT = "application/pdf,image/png,image/jpeg,image/webp"

/**
 * Card de envio do encaminhamento médico (PDF ou imagem) para especialidades restritas
 * (Psicologia / Nutrição). Ao concluir o upload, guarda o link do S3 em sessionStorage
 * ("encaminhamentoUrl") e dispara onUploaded(url) para liberar o avanço do fluxo.
 */
export default function EncaminhamentoUpload({ clientCPF, onUploaded }) {
  const inputRef = useRef(null)
  const [file, setFile] = useState(null)
  const [previewUrl, setPreviewUrl] = useState(null)
  const { url, loading, error, upload } = useUploader()

  const isImage = file && file.type.startsWith("image/")

  const handleSelect = (e) => {
    const selected = e.target.files && e.target.files[0]
    if (!selected) return
    setFile(selected)
    setPreviewUrl(selected.type.startsWith("image/") ? URL.createObjectURL(selected) : null)
  }

  const handleSend = async () => {
    if (!file) return
    const finalUrl = await upload(file, clientCPF)
    if (finalUrl) {
      sessionStorage.setItem("encaminhamentoUrl", finalUrl)
      onUploaded && onUploaded(finalUrl)
    }
  }

  return (
    <div className="encaminhamento-upload">
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPT}
        style={{ display: "none" }}
        onChange={handleSelect}
      />

      {!file && (
        <button type="button" className="enc-select-btn" onClick={() => inputRef.current.click()}>
          <FiUploadCloud /> Selecionar encaminhamento (PDF ou imagem)
        </button>
      )}

      {file && (
        <div className="enc-preview">
          {isImage && previewUrl ? (
            <img src={previewUrl} alt="Pré-visualização do encaminhamento" />
          ) : (
            <div className="enc-file">
              <FiFile />
              <span>{file.name}</span>
            </div>
          )}
          {!url && (
            <button type="button" className="enc-change" onClick={() => inputRef.current.click()}>
              Trocar arquivo
            </button>
          )}
        </div>
      )}

      {error && <p className="enc-error">{error}</p>}

      {url ? (
        <p className="enc-success">
          <FiCheckCircle /> Encaminhamento enviado com sucesso.
        </p>
      ) : (
        file && (
          <button type="button" className="enc-send-btn" onClick={handleSend} disabled={loading}>
            {loading ? "Enviando..." : "Enviar encaminhamento"}
          </button>
        )
      )}
    </div>
  )
}
